// Here are the trackers/tags used by the app
// - Analytics/GA4
// - Matomo (kind of GA4 clone)
// - Bing tracker
// - Meta/Facebook pixel tag
// - Criteo tracker (NOT EXTRACTED YET)
// - Spread widget (NOT EXTRACTED YET)

export function loadTags() {
  const container = document.getElementById('js-consent-banner')
  const attrs = container?.getAttribute('data-tags') || '{}'
  const props = JSON.parse(attrs) || {}

  // loadKelkoo()

  if (!props) {
    return
  }

  const { bingId, pixelId } = props

  // ga4Id && loadGoogleAnalyticsTag({ adwordsId, ga4Id })
  bingId && loadBingTracker(bingId)
  pixelId && loadFacebookPixelTag(pixelId)

  if (bingId && props.bingEvent) {
    window.uetq = window.uetq || []
    window.uetq.push(props.bingEvent)
  }
}

// Facebook/Meta pixel tag
function loadFacebookPixelTag(identifier) {
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    t['data-cookieconsent'] = 'marketing'
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js'
  )

  fbq('init', identifier)
  fbq('track', 'PageView')
}

// function loadKelkoo() {
//   const t = document.getElementsByTagName('script')[0]
//   const e = document.createElement('script')
//   e.async = true
//   e.src = 'https://s.kk-resources.com/leadtag.js'
//   e['data-cookieconsent'] = 'marketing'
//   t.parentNode.insertBefore(e, t)
// }

function loadBingTracker(bingId) {
  ;(function (w, d, t, r, u) {
    var f, n, i
    ;((w[u] = w[u] || []),
      (f = function () {
        var o = { ti: bingId }
        ;((o.q = w[u]), (w[u] = new UET(o)), w[u].push('pageLoad'))
      }),
      (n = d.createElement(t)),
      (n.src = r),
      (n.async = 1),
      (n['data-cookieconsent'] = 'statistics'),
      (n.onload = n.onreadystatechange =
        function () {
          var s = this.readyState
          ;(s && s !== 'loaded' && s !== 'complete') ||
            (f(), (n.onload = n.onreadystatechange = null))
        }),
      (i = d.getElementsByTagName(t)[0]),
      i.parentNode.insertBefore(n, i))
  })(window, document, 'script', '//bat.bing.com/bat.js', 'uetq')
}
